import { fetchOptions } from './csrf'

export interface WindowStickerSetting {
  id: string | null
  default_language: string
  xslt_text: string | null
  vehicle_format: number
  top_line_label_format: number
  top_line_format: number
  options_header_format: number
  options_format: number
  price_format: number
  price_retail_format: number
  dealer_name_format: number
  dealer_address_format: number
  dealer_phone_format: number
  dealer_email_format: number
  dealer_url_format: number
  hours_label_format: number
  hours_format: number
  created_at: string | null
  updated_at: string | null
}

interface WindowStickerSettingResponse {
  window_sticker_setting: WindowStickerSetting
}

interface ErrorResponse {
  errors: string[]
}

export const FORMAT_FIELDS = [
  { key: 'vehicle_format', label: 'Vehicle (Year/Make/Model)' },
  { key: 'top_line_label_format', label: 'Top Line Label' },
  { key: 'top_line_format', label: 'Top Line Value' },
  { key: 'options_header_format', label: 'Options Header' },
  { key: 'options_format', label: 'Options' },
  { key: 'price_format', label: 'Price' },
  { key: 'price_retail_format', label: 'Retail Price' },
  { key: 'dealer_name_format', label: 'Dealer Name' },
  { key: 'dealer_address_format', label: 'Dealer Address' },
  { key: 'dealer_phone_format', label: 'Dealer Phone' },
  { key: 'dealer_email_format', label: 'Dealer Email' },
  { key: 'dealer_url_format', label: 'Dealer URL' },
  { key: 'hours_label_format', label: 'Hours Label' },
  { key: 'hours_format', label: 'Hours' },
] as const

// Bit flags
export const BOLD = 1
export const ITALIC = 2
export const UNDERLINE = 4

export const windowStickerSettingsApi = {
  async show(): Promise<WindowStickerSetting> {
    const response = await fetch('/api/v1/settings/window-stickers', fetchOptions())
    if (!response.ok) throw new Error('Failed to load window sticker settings')
    const data: WindowStickerSettingResponse = await response.json()
    return data.window_sticker_setting
  },

  async update(params: Partial<Omit<WindowStickerSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<WindowStickerSetting> {
    const response = await fetch('/api/v1/settings/window-stickers', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ window_sticker_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: WindowStickerSettingResponse = await response.json()
    return data.window_sticker_setting
  },
}
